module.exports = __webpack_public_path__ + "img/top_b.1c0c1045.png";